/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ImageIcon({
  children,
  viewPath = "/DesignSystem/Svgs/ImageIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ImageIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 overflow="visible"
 style={{'--as-1-1khqJr': alignSelf,'--mt-2-1khqJr': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1khqJr': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1khqJr': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1khqJr': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1khqJr': opacity,'--w-10-1khqJr': typeof width === 'number' ? `${width}px` : width,'--h-11-1khqJr': typeof height === 'number' ? `${height}px` : height,'--a-7-1khqJr': isAnimated ? animation : "none",'--sd-8-1khqJr': isAnimated ? strokeDashoffset : 0,'--sd-9-1khqJr': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="ImageIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M2.5 2.5h27v27h-27z"
 style={{'--f-12-1khqJr': fill,'--s-13-1khqJr': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="ImageIcon.SvgPath:1"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M15.5 22.1l8.9-8.9 4.5 4.5M2.7 27.4l8.9-8.9 6.4 6.4"
 style={{'--f-12-1khqJr': fill,'--s-13-1khqJr': stroke}}
 className={`views-block ${styles.SvgPath1}`}
/>
<circle
  data-testid="ImageIcon.SvgCircle"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 cx={10}
 cy={9.7}
 r={2.8}
 style={{'--f-12-1khqJr': fill,'--s-13-1khqJr': stroke}}
 className={`views-block ${styles.SvgCircle}`}
/>
</svg>
{children}
</React.Fragment>)
}